import { useHead } from '#app'
import { createPaypalCardButton } from './paypal'
import { useRuntimeConfig } from '#app'

export const usePaypalHead = (paypalButton, paypalId, cartParams, router, callback) => {
  const config = useRuntimeConfig()
  const currency = config.public.currency

  // 判断是否已经加载过了paypal的sdk，如果加载过了就不再加载直接创建按钮
  if (typeof paypal === 'undefined') {
    useHead({
      script: [
        {
          src: `https://www.paypal.com/sdk/js?client-id=${paypalId}&components=card-fields,buttons,messages,funding-eligibility&enable-funding=card&currency=${currency}`,
          async: true,
          onload: () => {
            createPaypalCardButton(paypalButton, cartParams, router, callback)
          },
        },
      ],
    })
  } else {
    createPaypalCardButton(paypalButton, cartParams, router, callback)
  }
}
